module.exports = __webpack_public_path__ + "media/shard_blogs/free-fd8738cb.jpg";